import Project from 'src/entities/Project';
import * as React from 'react';
import ProjectActionToolbarContainer from 'src/modules/project/partials/action-toolbar/ProjectActionToolbar.container';
import HtmlFormater from 'src/utils/htmlFormaterUtil';

interface Props {
  project: Project;
  invest: boolean;
  closedProject: boolean;
}

const ProjectFinancialComponent: React.StatelessComponent<Props> = (props: Props) => (
    <div className="col-sm-9">
      <div className="padding-left-30">
        <div className="gap-50"/>

        <h3>
          Datos Financieros
        </h3>
        <div className="gap-20"/>
        <div className="row">
          <div className="col-sm-12">
            <div
              className="from-rich-editor"
              dangerouslySetInnerHTML={{__html: HtmlFormater.parseMarkDownImages(props.project.environmentDescription)}}
            />
          </div>
        </div>
        <div className="gap-50"/>
        <ProjectActionToolbarContainer
          project={props.project}
          invest={props.invest}
          closedProject={props.closedProject}
        />
        <div className="gap-50"/>
      </div>
    </div>

  )
;

export default ProjectFinancialComponent;



// WEBPACK FOOTER //
// ./src/modules/project/partials/ProjectFinancial.component.tsx